import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/**
 * 施工実績スライダー（Swiper）を初期化する関数
 */
export default function initResultsSwiper() {
	// 念のため、画面内にターゲットの要素が存在するときだけ動かす（エラー落ち防止）
	const swiperTarget = document.querySelector(".results-swiper");
	if (!swiperTarget) return;

	const resultsSwiper = new Swiper(".results-swiper", {
		modules: [Navigation, Pagination],

		loop: true,
		slidesPerView: 1.2,
		centeredSlides: true,
		spaceBetween: 16,
		breakpoints: {
			768: {
				slidesPerView: 2.5,
				spaceBetween: 24,
			},
			1201: {
				slidesPerView: 3.4,
				spaceBetween: 40,
			},
			// 1921: {
			// 	slidesPerView: 5.5,
			// 	spaceBetween: 40,
			// },
		},

		// ページネーション（ドットナビ）
		pagination: {
			el: ".result-swiper-pagination",
			clickable: true,
		},

		// ナビゲーション矢印
		navigation: {
			nextEl: ".result-swiper-button-next",
			prevEl: ".result-swiper-button-prev",
		},
	});

	return resultsSwiper;
}
